import { render, staticRenderFns } from "./ChannelCardGroupGrid.vue?vue&type=template&id=fa79cdee&scoped=true"
import script from "./ChannelCardGroupGrid.vue?vue&type=script&lang=js"
export * from "./ChannelCardGroupGrid.vue?vue&type=script&lang=js"
import style0 from "./ChannelCardGroupGrid.vue?vue&type=style&index=0&id=fa79cdee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa79cdee",
  null
  
)

export default component.exports